<template>
    <q-card >
        <q-card-section>
            <div class="text-h6">Share this Map</div>
        </q-card-section>
        <q-card-section>
            <div>
                <div>Save or share this map with a link embedded in a downloadable HTML file.</div>
                <q-btn @click="downloadURL()" icon="download" class="q-pa-sm q-mt-sm" aria-label="Download map link" color="primary">
                <span class="q-pl-sm" >Download Map Link</span>
                <q-btn dense  size="xs" flat class="gray q-ml-md" icon="help_outline" @click.stop="infoDialogs['downloadMapLink'].model = !infoDialogs['downloadMapLink'].model" aria-label="'Copy Map Link' help"/>
                </q-btn>
            </div>
            <div v-if="b64URLLength <=2000" class="q-mt-md">
                <div>Save or share this map by copying a link to your clipboard.</div>
                <q-btn @click="shareURL()" icon="share" class="q-pa-sm q-mt-sm" :color="shareLinkColor" aria-label="Copy saved map link">
                <span class="q-pl-sm"  v-if="!copied">Copy Map Link</span>
                <span v-if="copied" class="q-pl-sm">Link Copied</span>
                <q-btn dense  size="xs" flat class="gray q-ml-md" icon="help_outline" @click.stop="infoDialogs['copyMapLink'].model = !infoDialogs['copyMapLink'].model" aria-label="'Copy Map Link' help"/>
                </q-btn>              
            </div>
        </q-card-section>
        
        <q-card-actions align="right">
            <q-btn flat label="OK" color="primary" v-close-popup aria-label="OK" />
        </q-card-actions>
    </q-card>
    <div v-for="(infoObj, name) in infoDialogs" :key="name" style="width: calc(33vw -1px); ">
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
</template>

<script setup lang="ts">
import { toRefs, computed, onMounted, onUnmounted, ref, useAttrs } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import InfoDialog from "./InfoDialog.vue";
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
const props = defineProps({
    b64URL: { type: String },
})
const emit = defineEmits(['enter'])
const { b64URL } = toRefs(props)

const {  setBase64QueryString,  processedData, base64QueryString } = useMapItems()
const {  objToBase64,  } = useHelpers();

const shareURL = () => {
    // console.log(queryParams.value)
    // console.log(base64QueryString.value)
    // console.log(b64URL.value)
    copyURL(b64URL.value)
  }
  const copied = ref(false)

  const b64URLLength = ref(0)
  const copyURL = async (mytext) => {
    // console.log(mytext)
    try {
      await navigator.clipboard.writeText(mytext);
      copied.value = true
      // console.log('Copied');
      setTimeout(() => {
        copied.value = false
      }, 2000);
    } catch ($e) {
      alert('Cannot copy');
    }
  }
  const shareLinkColor = computed(() => {
    if (copied.value) { return "secondary" }
    else { return "primary" }
  })

   
  // // DOWNLOAD MAP REDIRECT
  const redirectContent = ref('');
  // Function to read the HTML file
  const readFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const result = e.target.result;
      if (typeof result === 'string') {
        redirectContent.value = result;
      } else {
        console.error('Unexpected result type:', typeof result);
      }
    };
    reader.readAsText(file);
  };
  // Function to escape special characters in the search text
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };
  const replaceHTMLText = (searchText, replaceText) => {
    const escapedSearchText = escapeRegExp(searchText);
    const searchTextRegex = new RegExp(escapedSearchText, 'g');
    redirectContent.value = redirectContent.value.replace(searchTextRegex, replaceText);
  };

  // Function to download the modified HTML file
  const downloadFile = async (filename) => {
    const blob = new Blob([redirectContent.value], { type: 'text/html' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  // Function to fetch the HTML file content
  const fetchFileContent = async () => {
    try {
      const response = await fetch('MarineMappingTool_SavedSites.html');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      redirectContent.value = await response.text();
    } catch (error) {
      console.error('Error fetching file:', error);
    }
  };
  const downloadURL = async() =>{
    await fetchFileContent()
    replaceHTMLText("https://XXXXX", b64URL.value);
    const timestamp = Date.now(); 
    // console.log(new Date(timestamp))
    downloadFile(`MarineMappingTool_${getTimestamp()}.html`);
  }

 const getTimestamp =()=>{
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
}

  const infoDialogs = ref({
    copyMapLink: {
      pName: "Copy Map Link",
      model: false,
      text: "Clicking on the 'Copy Map Link' button will generate a special URL which stores many aspects of the current state of the map, including the AOI(s) entered, the active section of the tool, and any data that has been processed within the tool.  The processed data makes return visits to the tool substantially faster, particularly in the case of large AOIs.  This URL will be automatically copied to the computer's clipboard and can then be pasted into an email, document or otherwise shared or saved for future reference."
    },
    downloadMapLink: {
      pName: "Download Map Link",
      model: false,
      text: "Clicking on the 'Download Map Link' button will generate a HTML file which can be downloaded for future use or shared with others. This HTML file incorporates a special URL which stores many aspects of the current state of the map, including the AOI(s) entered, the active section of the tool, and any data that has been processed within the tool.  The processed data makes return visits to the tool substantially faster, particularly in the case of large AOIs.  When the downloaded HTML file is opened, the user's browser will redirect to this special URL and the tool will open with the information generated during the session in which the HTML file was generated. An internet connection is required to use the downloaded file."
    },
  })

  onMounted( () => {
    // console.log(b64URL.value)
    // console.log(b64URL.value.length)
    b64URLLength.value = b64URL.value.length
  })
</script>

<style scoped>
</style>
